import AirlineDetailsCard from './AirlineDetailsCard';

export default AirlineDetailsCard;
